export default __webpack_public_path__ + "static/media/work-from-home.b807084d.png";